// idleSessionService.js
//
// Vue 2 wrapper around createIdleSession (idleSession.js, unchanged).
// One module-level instance. Its lifetime follows the auth state, not any
// component's lifecycle. Shared state is made reactive with Vue.observable
// (Vue 2.6+), so any component can read it through computed properties.

import Vue from 'vue';
import { createIdleSession } from './idleSession';

export const idleState = Vue.observable({
  status: 'inactive',   // 'inactive' | 'active' | 'warning'
  remainingMs: 0,
});

let session = null;

function reset() {
  session = null;
  idleState.status = 'inactive';
  idleState.remainingMs = 0;
}

/**
 * Start tracking. Call when the user becomes authenticated (after login or on
 * page load with a valid session). Safe to call repeatedly: it restarts.
 *
 * @param {object}   options
 * @param {Function} options.onExpire  log out locally (idle timeout, or another tab logged out)
 * @param {number}   [options.idleMs]  default 30 min
 * @param {number}   [options.graceMs] default 60 s
 * @param {boolean}  [options.activityDismissesWarning] default false
 */
export function startIdleSession(options) {
  if (session) session.end();
  var onExpire = options.onExpire;
  session = createIdleSession(Object.assign({}, options, {
    onChange: function (status, remainingMs) {
      idleState.status = status;
      idleState.remainingMs = remainingMs;
    },
    onExpire: function () {
      reset();
      onExpire();
    },
  }));
}

/** Call from every explicit logout path (button, 401 interceptor). Logs out all tabs. Idempotent. */
export function endIdleSession() {
  if (session) session.end();
  reset();
}

/** User clicked STAY. Call after the server session has been refreshed. */
export function stayIdleSession() {
  if (session) session.stay();
}
